import AppMigrationDatabase from './AppMigrationDatabase';

export default AppMigrationDatabase;